export default __webpack_public_path__ + "static/media/add-to-cart.f1de56cc.png";